<script setup>
// M26.5 Part 8 — flat capability chips, grouped. Empty groups never render.
import { computed } from 'vue';
import { groupCapabilities } from './capabilityGroups';

const props = defineProps({
  capabilities: { type: Array, default: () => [] },
  compact: { type: Boolean, default: false },
});

const groups = computed(() => groupCapabilities(props.capabilities));
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="flex flex-col gap-2">
    <div
      v-for="group in groups"
      :key="group.label"
      class="flex flex-wrap items-center gap-1.5"
    >
      <span
        class="text-[10px] font-semibold text-n-slate-7 uppercase tracking-wider shrink-0"
        :class="compact ? 'w-auto' : 'w-24'"
      >
        {{ group.label }}
      </span>
      <span
        v-for="cap in group.items"
        :key="cap"
        class="text-[10px] px-1.5 py-0.5 rounded bg-n-alpha-2 text-n-slate-8 capitalize"
      >
        {{ cap.replace(/_/g, ' ') }}
      </span>
    </div>
  </div>
</template>
